<template>
  <div>
    <top-header :type="7" :placeholder="'请输入项目名称'" @comfirmText="comfirmText"/>
    <div class="list_main">
      <div id="line" class="pad_top"></div>
      <div class="cover_opc" @touchmove.prevent v-show="showCover"></div>
      <div class="tab_con m_flex_box flex_jz fixed">
        <div class="inner_con">
          <p class="text m_flex_box flex_vc flex_hc" :class="tab.showArea === true ? 'active' : ''" @click="setTab('showArea')">
            <span class="line_comp1">{{tabText.showArea ? tabText.showArea : '区域'}}</span>
            <van-icon name="play" />
          </p>
          <transition name="slide-y" mode="out-in">
            <div class="inner_list inner_form" v-show="tab.showArea">
              <p :class="formData.xzqh === item.xzqh_code ? 'active' : ''" @click="setVal('xzqh', item.xzqh_code, item.xzqh_name, 'showArea')"
                 v-for="(item, index) in xzqhArray" :key="index">{{item.xzqh_name}}</p>
            </div>
          </transition>
        </div>
        <div class="inner_con">
          <p class="text m_flex_box flex_vc flex_hc" :class="tab.showPrice === true ? 'active' : ''" @click="setTab('showPrice')">
            <span class="line_comp1">{{tabText.showPrice ? tabText.showPrice : '价格'}}</span>
            <van-icon name="play" />
          </p>
          <transition name="slide-y" mode="out-in">
            <div class="price_list inner_form" v-show="tab.showPrice">
              <div class="m_flex_box price_inner">
                <div class="left" @touchmove.prevent>
                  <p :class="priceType === 1 ? 'active' : ''" @click="changePrice(1)">单价</p>
                  <p :class="priceType === 2 ? 'active' : ''" @click="changePrice(2)">总价</p>
                </div>
                <div class="right flex-1" v-show="priceType === 1">
                  <p :class="formData.price === '' ? 'active' : ''" @click="setVal('price', '', '', 'showPrice')">不限</p>
                  <div v-show="xzqhDefault==='320300'">
                    <p  :class="formData.price === item.value ? 'active' : ''" @click="setVal('price', item.value, item.text, 'showPrice')" v-for="(item, index) in utilPrice" :key="index">{{item.text}}</p>
                  </div>

                  <div v-show="xzqhDefault!=='320300'">
                    <p :class="formData.price === item.value ? 'active' : ''" @click="setVal('price', item.value, item.text, 'showPrice')" v-for="(item, index1) in utilPrice1" :key="index1">{{item.text}}</p>
                  </div>
                </div>
                <div class="right flex-1" v-show="priceType === 2">
                  <p :class="formData.totalPrice === '' ? 'active' : ''" @click="setVal('totalPrice', '', '', 'showPrice')">不限</p>
                  <div v-show="xzqhDefault==='320300'">
                    <p  :class="formData.totalPrice === item.value ? 'active' : ''" @click="setVal('totalPrice', item.value, item.text, 'showPrice')" v-for="(item, index) in totalPrice" :key="index">{{item.text}}</p>
                  </div>
                  <div v-show="xzqhDefault!=='320300'">
                    <p :class="formData.totalPrice === item.value ? 'active' : ''" @click="setVal('totalPrice', item.value, item.text, 'showPrice')" v-for="(item, index1) in totalPrice1" :key="index1">{{item.text}}</p>
                  </div>
                </div>
              </div>
              <div class="bottom_con m_flex_box flex_vc flex_jz">
                <div class="m_flex_box flex_vc">
                  <span class="tit">自定义</span>
                  <input type="number" v-model="min"><i>-</i><input type="number" v-model="max"><p><span v-show="priceType === 2">万</span>元</p>
                </div>
                <van-button type="info" @click="priceConfirm">确定</van-button>
              </div>
            </div>
          </transition>
        </div>
        <div class="inner_con">
          <p class="text m_flex_box flex_vc flex_hc" :class="tab.showHx === true ? 'active' : ''" @click="setTab('showHx')">
            <span class="line_comp1">{{tabText.showHx ? tabText.showHx : '户型'}}</span>
            <van-icon name="play" />
          </p>
          <transition name="slide-y" mode="out-in">
            <div class="inner_list inner_form" v-show="tab.showHx">
              <p :class="formData.hx === '' ? 'active' : ''" @click="setVal('hx', '', '', 'showHx')">不限</p>
              <p :class="formData.hx === 1 ? 'active' : ''" @click="setVal('hx', 1, '一居室', 'showHx')">一居室</p>
              <p :class="formData.hx === 2 ? 'active' : ''" @click="setVal('hx', 2, '二居室', 'showHx')">二居室</p>
              <p :class="formData.hx === 3 ? 'active' : ''" @click="setVal('hx', 3, '三居室', 'showHx')">三居室</p>
              <p :class="formData.hx === 4 ? 'active' : ''" @click="setVal('hx', 4, '四居室', 'showHx')">四居室</p>
              <p :class="formData.hx === 5 ? 'active' : ''" @click="setVal('hx', 5, '五居室', 'showHx')">五居室</p>
              <p :class="formData.hx === 6 ? 'active' : ''" @click="setVal('hx', 6, '五居室及以上', 'showHx')">五居室及以上</p>
            </div>
          </transition>
        </div>
        <div class="inner_con">
          <p class="text m_flex_box flex_vc flex_hc" :class="tab.showType === true ? 'active' : ''" @click="setTab('showType')">
            <span class="line_comp1">更多</span>
            <van-icon name="play" />
          </p>
          <transition name="slide-y" mode="out-in">
            <div class="more_list inner_form" v-show="tab.showType">
              <div class="more_con">

                <div class="row_con">
                  <h4>销售状态</h4>
                  <div class="row_inner m_flex_box flex_vc flex_vw">
                    <span :class="formData.xsqk === 1 ? 'active' : ''" @click="setValB('xsqk', 1)">在售</span>
                    <span :class="formData.xsqk === 2 ? 'active' : ''" @click="setValB('xsqk', 2)">未售</span>
                    <span :class="formData.xsqk === 3 ? 'active' : ''" @click="setValB('xsqk', 3)">售罄</span>
                  </div>
                </div>

                <div class="row_con">
                  <h4>房屋类型</h4>
                  <div class="row_inner m_flex_box flex_vc flex_vw">
                    <span :class="formData.lx === '住宅' ? 'active' : ''" @click="setValB('lx', '住宅')">住宅</span>
                    <span :class="formData.lx === '商服' ? 'active' : ''" @click="setValB('lx', '商服')">商服</span>
                    <span :class="formData.lx === '办公' ? 'active' : ''" @click="setValB('lx', '办公')">办公</span>
                  </div>
                </div>

                <div class="row_con">
                  <h4>最新预售时间</h4>
                  <div class="row_inner m_flex_box flex_vc flex_vw">
                    <span :class="formData.yssj === 1 ? 'active' : ''" @click="setValB('yssj', 1)">一个月内</span>
                    <span :class="formData.yssj === 2 ? 'active' : ''" @click="setValB('yssj', 2)">三个月内</span>
                    <span :class="formData.yssj === 3 ? 'active' : ''" @click="setValB('yssj', 3)">半年内</span>
                  </div>
                </div>

                <div class="row_con">
                  <h4>物业类型</h4>
                  <div class="row_inner m_flex_box flex_vc flex_vw">
                    <span :class="formData.structType === '多层' ? 'active' : ''" @click="setValB('structType', '多层')">多层</span>
                    <span :class="formData.structType === '小高层' ? 'active' : ''" @click="setValB('structType', '小高层')">小高层</span>
                    <span :class="formData.structType === '高层' ? 'active' : ''" @click="setValB('structType', '高层')">高层</span>
                    <span :class="formData.structType === '洋房' ? 'active' : ''" @click="setValB('structType', '洋房')">洋房</span>
                    <span :class="formData.structType === '别墅叠拼' ? 'active' : ''" @click="setValB('structType', '别墅叠拼')">别墅叠拼</span>
                    <span :class="formData.structType === '别墅独栋' ? 'active' : ''" @click="setValB('structType', '别墅独栋')">别墅独栋</span>
                    <span :class="formData.structType === '别墅联排' ? 'active' : ''" @click="setValB('structType', '别墅联排')">别墅联排</span>
                    <span :class="formData.structType === '别墅双拼' ? 'active' : ''" @click="setValB('structType', '别墅双拼')">别墅双拼</span>
                    <span :class="formData.structType === '办公' ? 'active' : ''" @click="setValB('structType', '办公')">办公</span>
                    <span :class="formData.structType === '写字楼' ? 'active' : ''" @click="setValB('structType', '写字楼')">写字楼</span>
                    <span :class="formData.structType === '公寓' ? 'active' : ''" @click="setValB('structType', '公寓')">公寓</span>
                    <span :class="formData.structType === '商铺' ? 'active' : ''" @click="setValB('structType', '商铺')">商铺</span>
                    <span :class="formData.structType === '商业' ? 'active' : ''" @click="setValB('structType', '商业')">商业</span>
                  </div>
                </div>
              </div>
              <div class="m_flex_box flex_vc flex_jz btn_con">
                <button class="reset" @click="reset">重置</button>
                <button class="confirm" @click="confirm">确定</button>
              </div>
            </div>
          </transition>
        </div>
        <div class="inner_con">
          <p class="text m_flex_box flex_vc flex_hc" :class="tab.showSort === true ? 'active' : ''" @click="setTab('showSort')">
            <span class="line_comp1">{{tabText.showSort ? tabText.showSort : '排序'}}</span>
            <van-icon name="play" />
          </p>
          <transition name="slide-y" mode="out-in">
            <div class="inner_list inner_form" v-show="tab.showSort">
              <p :class="!formData.order ? 'active' : ''" @click="setVal('order', 0, '', 'showSort')">默认排序</p>
              <p :class="formData.order === 1 ? 'active' : ''" @click="setVal('order', 1, '单价从低到高', 'showSort')">单价从低到高</p>
              <p :class="formData.order === 2 ? 'active' : ''" @click="setVal('order', 2, '单价从高到底', 'showSort')">单价从高到底</p>
              <p :class="formData.order === 3 ? 'active' : ''" @click="setVal('order', 3, '开盘时间升序', 'showSort')">开盘时间升序</p>
              <p :class="formData.order === 4 ? 'active' : ''" @click="setVal('order', 4, '开盘时间降序', 'showSort')">开盘时间降序</p>
              <p :class="formData.order === 5 ? 'active' : ''" @click="setVal('order', 5, '访问量', 'showSort')">访问量</p>
              <p :class="formData.order === 6 ? 'active' : ''" @click="setVal('order', 6, '综合评分', 'showSort')">综合评分</p>
            </div>
          </transition>
        </div>
      </div>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="list_con new_list">
            <div class="inner m_flex_box flex_vc" v-for="(item, index) in list" :key="index" @click="toURL(item.id,item.old,formData.xzqh)" >
              <img class="banner" v-lazy="imgPath + 'sImgMin/' + item.xmfm + '.jpg'">
              <div class="new_r">
                <div class="m_flex_box flex_vc flex_jz tit">
                  <h4 class="line_comp1">{{item.tgmc}}</h4>
                  <i>{{item.xsqkStr}}</i>
                </div>
                <p class="line_comp1 col_gray">{{item.xmdz ? item.xmdz : '暂无地址信息'}}</p>
                <div class="m_flex_box flex_jz flex_vc">
                  <div class="m_flex_box flex_vc info">
                    <p>评分：<span>{{item.zScore}}</span></p>
                    <p>访问量：{{item.fwl | formatwan}}</p>
                  </div>
                  <a @click.stop="callTo(item.zxdh, 3, item.id)" class="tel"><img src="@/assets/img/tel.png" alt=""></a>
                </div>
                <div class="m_flex_box flex_jz flex_vc">
                  <div class="col_red m_flex_box flex_vb">
                    <h4>{{item.priceStr}}</h4><span v-show="item.priceStr !== '暂无'">元/平</span>
                  </div>
                  <p v-if="item.ksts" class="m_flex_box flex_vc text">
                    <span @click.stop @click="toOneHouseOnePrice(item.id,item.xzqh)">一房一价</span>
                    <van-icon name="play" />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <slide-img></slide-img>
  </div>
</template>

<script>
import qs from 'qs';
import topHeader from '@/components/header'
import slideImg from '@/components/slideImg'
export default {
  name: 'FindProjectName',
  data() {
    return {
      ad: [],
      utilPrice: [{
        value: '5000-10000',
        text: '10000元/m²以下'
      },{
        value: '10001-15000',
        text: '10001-15000元/m²'
      },{
        value: '15001-17000',
        text: '15001-17000元/m²'
      },{
        value: '17001-20000',
        text: '17001-20000元/m²'
      },{
        value: '20001-25000',
        text: '20001-25000元/m²'
      },{
        value: '25001-30000',
        text: '25001-30000元/m²'
      },{
        value: '30001-50000',
        text: '30001元/m²以上'
      }],
      utilPrice1: [{
        value: '1000-5000',
        text: '5000元/m²以下'
      },{
        value: '5001-6000',
        text: '5001-6000元/m²'
      },{
        value: '6001-7000',
        text: '6001-7000元/m²'
      },{
        value: '7001-8000',
        text: '7001-8000元/m²'
      },{
        value: '8001-9000',
        text: '8001-9000元/m²'
      },{
        value: '9001-10000',
        text: '9001-10000元/m²'
      },{
        value: '10001-20000',
        text: '10000元/m²以上'
      }],
      totalPrice: [{
        value: '100000-1000000',
        text: '100万以下'
      },{
        value: '1000000-1500000',
        text: '100-150万元'
      },{
        value: '1510000-2000000',
        text: '151-200万元'
      },{
        value: '2010000-2500000',
        text: '201-250万元'
      },{
        value: '2510000-3000000',
        text: '251-300万元'
      },{
        value: '3010000-4000000',
        text: '301-400万元'
      },{
        value: '4000000-100000000',
        text: '400万以上'
      }],
      totalPrice1: [{
        value: '10000-500000',
        text: '50万以下'
      },{
        value: '510000-700000',
        text: '51-70万元'
      },{
        value: '710000-800000',
        text: '71-80万元'
      },{
        value: '810000-900000',
        text: '81-90万元'
      },{
        value: '910000-1000000',
        text: '91-100万元'
      },{
        value: '1010000-1200000',
        text: '101-120万元'
      },{
        value: '1200000-5000000',
        text: '120万以上'
      }],
      tab: {
        showArea: false,
        showPrice: false,
        showHx: false,
        showType: false,
        showSort: false,
      },
      tabText: {
        showArea: '',
        showPrice: '',
        showHx: '',
        showSort: '',
      },
      priceType: 1,
      formData: {
        pageSize:10,
        currPageNo:1,
        xzqh: this.main.getHostArea(),
        xsjgq: '',
        xsjgz: '',
        mjq: '',
        mjz: '',
        zjgq: '',
        zjgz: '',
        lx: '',
        xsqk:'',
        hx: '',
        order:0,
        mc:'',
        price: '',
        totalPrice: '',
        yssj: '',
        structType: ''
      },
      offsetTop: 0,
      min: '',
      max: '',
      showPad: false,
      showCover: false,
      isLoading: false,
      loading: false,
      finished: false,
      xzqhDefault:this.main.getHostArea(),
      xzqhArray:[],
      items:'',
      list: [],
      flag:false,
      timer: null
    };
  },
  components: {
    topHeader,
    slideImg
  },
  filters: {
    formatwan(param) {
      if(param >= 10000) {
        return (param / 10000).toFixed(2) + 'w'
      } else {
        return param
      }
    }
  },
  mounted() {
    this.getArea();
  },
  methods: {
    callTo(phone, lx, infoId) {
      if(!phone) {
        this.$dialog.alert({
          title: '提示',
          message: '暂无可拨打电话'
        });
        return;
      }
      this.$new.post('telTj/addTeltj.do', qs.stringify({
        phone,
        lx,
        infoId
      })).then(res => {
        window.location.href = `tel:${phone}`
      })
    },
    comfirmText(data) {
      this.$set(this.formData, 'mc', data)
      this.$set(this.formData, 'currPageNo', 1)
      this.loading = false;
      this.finished = false;
      this.$set(this, 'list', [])
      this.onLoad();
    },
    toURL(itemId,old,xzqh){
      if(old==1){
        this.$router.push({
          path: '/projectDetailIndex',
          query: {
            itemId: itemId
          }
        })
      }else{
        this.$router.push({
          path: '/projectDetail',
          query: {
            itemId: itemId
          }
        })
      }
    },
    toOneHouseOnePrice(itemId,xzqh) {
      this.$router.push({
        path: '/oneHouseOnePrice',
        query: {itemId,xzqh}
      })
    },

    getArea() {
      this.$new.post('xzqh/getXzqh.do').then(res => {
        if(res.obj) {
          if(this.xzqhDefault==='320300'){
            this.xzqhArray = res.obj[0].xzqhs;
            this.items = {xzqh_code:'320300',xzqh_name:'不限'};
            this.xzqhArray.splice(0,0, this.items);
          }else{
            res.obj.forEach((item) => {
              if(this.xzqhDefault===item.xzqh_code){
                this.$set(this, 'xzqhArray', [item])
              }
            });
          }
        }
      })
    },
    onRefresh() {
      this.loading = false;
      this.finished = false;
      this.$set(this.formData, 'currPageNo', 1)
      this.$set(this, 'list', [])
      this.onLoad(1);
    },

    getTuiJian(){
      this.$new.post('promoteHouse/getTypePage.do', qs.stringify({
        xzqh: this.main.getHostArea(),
        currPageNo: 1,
        pageSize:6,
        type:6
      })).then(res => {
        if(res.obj) {
          this.$set(this, 'list', res.obj)
        }
      })
    },

    onLoad(type) {
      if(!this.timer){
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50)
        if(this.formData.currPageNo==1&&this.formData.mc===''&&this.flag==false){
          this.getTuiJian();
        }
        this.$new.post('itemInfo/getByPage.do', qs.stringify(this.formData)).then(res => {
          if(type) {
            this.isLoading = false;
          }
          if(res.success) {
            this.list = this.list.concat(res.obj)
            this.loading = false;
            this.$set(this.formData, 'currPageNo', this.formData.currPageNo + 1);
          } else {
            this.finished = true;
          }
        })
      }
    },
    setTab(type) {
      this.$set(this, 'flag', true)
      this.showPad =  true;
      for(let key in this.tab) {
        if(type === key) {
          this.$set(this.tab, type, !this.tab[type]);
        } else {
          this.$set(this.tab, key, false)
        }
        if(this.tab[type]) {
          this.showCover = true
        } else {
          this.showCover = false
        }
      }
    },
    setVal(type, v, t, tab) {
      this.$set(this, 'flag', true)
      this.$set(this.formData, type, v);
      if(type === 'totalPrice') {
        this.$set(this.formData, 'zjgq', v.split('-')[0])
        this.$set(this.formData, 'zjgz', v.split('-')[1])
      } else if(type === 'price'){
        this.$set(this.formData, 'xsjgq', v.split('-')[0])
        this.$set(this.formData, 'xsjgz', v.split('-')[1])
      }
      if(tab) {
        this.$set(this.tab, tab, false);
        this.$set(this.tabText, tab, t);
        this.showCover = false;
      }
      this.loading = false;
      this.finished = false;
      this.$set(this.formData, 'currPageNo', 1)
      this.list = [];
      this.onLoad();
    },
    setValB(type, v) {
      this.$set(this, 'flag', true)
      if(this.formData[type] === v) {
        this.$set(this.formData, type, '');
      } else {
        this.$set(this.formData, type, v);
      }
    /*  this.loading = false;
      this.finished = false;
      this.$set(this.formData, 'currPageNo', 1)
      this.list = [];
      this.onLoad();*/
    },
    reset() {
      this.$set(this.formData, 'lx', '');
      this.$set(this.formData, 'yssj', '');
      this.$set(this.formData, 'structType', '');
      this.$set(this.formData, 'xsqk', '');
      this.$set(this.tab, 'showType', false);
      this.showCover = false;
      this.loading = false;
      this.finished = false;
      this.$set(this.formData, 'currPageNo', 1)
      this.list = [];
      this.onLoad();
    },
    confirm() {
      this.$set(this.tab, 'showType', false);
      this.showCover = false;
      this.loading = false;
      this.finished = false;
      this.$set(this.formData, 'currPageNo', 1)
      this.list = [];
      this.onLoad();
    },
    // 价格判断
    priceConfirm() {
      this.$set(this, 'flag', true)
      if(this.min && this.max) {
        if(this.min > this.max) {
          if(this.priceType === 1) {
            this.$set(this.formData, 'xsjgq', this.max);
            this.$set(this.formData, 'xsjgz', this.min);
            this.min = this.formData.xsjgq;
            this.max = this.formData.xsjgz;
          } else {
            this.$set(this.formData, 'zjgq', this.max * 10000);
            this.$set(this.formData, 'zjgz', this.min * 10000);
            this.min = this.formData.zjgq / 10000;
            this.max = this.formData.zjgz / 10000;
          }
        } else {
          if(this.priceType === 1) {
            this.$set(this.formData, 'xsjgz', this.max);
            this.$set(this.formData, 'xsjgq', this.min);
            this.min = this.formData.xsjgq;
            this.max = this.formData.xsjgz;
          } else {
            this.$set(this.formData, 'zjgz', this.max * 10000);
            this.$set(this.formData, 'zjgq', this.min * 10000);
            this.min = this.formData.zjgq / 10000;
            this.max = this.formData.zjgz / 10000;
          }
        }
        this.currPageNo = 1;
        this.loading = false;
        this.finished = false;
        this.$set(this.formData, 'currPageNo', 1)
        this.list = [];
        this.onLoad();
        if(this.priceType === 1) {
          this.$set(this.tabText, 'showPrice', this.min + '-' + this.max + '万元');
        } else {
          this.$set(this.tabText, 'showPrice', this.min + '-' + this.max + '万元');
        }
      }
      this.$set(this.tab, 'showPrice', false);
      this.showCover = false;
    },
    changePrice(type) {
      this.priceType = type
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'ProjectDetail' || to.name === 'ProjectDetailIndex'){
      this.$store.dispatch('saveView', ['FindProjectName']).then(() => {
        next()
      })
    } else {
      this.$store.dispatch('saveView', []).then(() => {
        next()
      })
    }
  },
};
</script>
<style lang="less" scoped>
.list_main{
  background-color: #fff;
  h4{
    font-size: 0.38rem;
    font-weight: 600;
  }
  .tab_con{
    padding: 0 0.16rem;
    font-size: 0.28rem;
    position: relative;
    border-bottom: 1px solid #E9E9E9;
    z-index: 2;
    background-color: #fff;
    &.fixed{
      position: fixed;
      top: 1.1rem;
      left: 0;
      right: 0;
      border-top: 1px solid #E9E9E9;
    }
    .inner_con{
      .text{
        padding: 0.2rem 0rem;
        text-align: center;
        width: 1.2rem;
        .van-icon{
          transition: all 0.3s;
          color: #CECECE;
          transform: rotate(90deg);
          margin-left: 0.06rem;
          font-size: 0.2rem;
        }
        &.active{
          color: #2F72F5;
          .van-icon{
            transform: rotate(-90deg);
            color: #2F72F5;
          }
        }
      }
      .inner_form{
        background-color: #fff;
        position: absolute;
        left: 0;
        right: 0;
        top: calc(100% + 0.02rem);
        max-height: 7.12rem;
        overflow: auto;
      }
      .inner_list{
        padding: 0 0.5rem;
        p{
          line-height: 0.99rem;
          box-sizing: border-box;
          border-bottom: 1px solid #F4F4F4;
          text-align: center;
          &:last-child{
            border: none;
          }
          &.active{
            color: #2F72F5;
          }
        }
      }
      .price_list{
        .price_inner{
          height: 5.92rem;
        }
        .left{
          border-right: 1px solid #f4f4f4;
          width: 45%;
        }
        .right{
          box-sizing: border-box;
          padding-left: 0.2rem;
          max-height: 5.92rem;
          overflow: auto;
        }
        p{
          line-height: 0.99rem;
          box-sizing: border-box;
          border-bottom: 1px solid #F4F4F4;
          text-align: center;
          &:last-child{
            border: none;
          }
          &.active{
            color: #2F72F5;
          }
        }
      }
      .bottom_con{
        height: 1.2rem;
        box-sizing: border-box;
        border-top: 1px solid #f4f4f4;
        padding: 0 0.3rem;
        input{
          width: 1.38rem;
          height: 0.78rem;
          border: 1px solid #f4f4f4;
          text-align: center;
        }
        .tit{
          margin-right: 0.2rem;
        }
        i{
          margin: 0.1rem;
        }
        p{
          margin-left: 0.2rem;
        }
        .van-button{
          height: 0.78rem;
        }
      }
    }
  }
}
.more_list{
  padding: 0 0.3rem 0;
  h4{
    font-size: 0.3rem;
    margin-bottom: 0.3rem;
  }
  .more_con{
    padding-top: 0.46rem;
    height: 5.92rem;
    overflow: auto;
    box-sizing: border-box;
  }
  .btn_con{
    height: 1.2rem;
    box-sizing: border-box;
    border-top: 1px solid #f4f4f4;
    button{
      width: 3.3rem;
      line-height: 0.8rem;
      font-size: 0.28rem;
      border-radius: 0.02rem;
      &.reset{
        background-color: #EAF1FF;
        color: #2F72F5;
      }
      &.confirm{
        background-color: #2F72F5;
        color: #fff;
      }
    }
  }
  .row_con{
    margin-bottom: 0.54rem;
  }
  span{
    background-color: #F6F6F6;
    line-height: 0.66rem;
    width: 1.62rem;
    margin-right: 0.12rem;
    border-radius: 0.02rem;
    text-align: center;
    margin-bottom: 0.12rem;
    box-sizing: border-box;
      border: 1px solid #F6F6F6;
    &:nth-child(4n) {
      margin-right: 0;
    }
    &.active{
      color: #2F72F5;
      background-color: #EAF1FF;
      border: 1px solid #2F72F5;
    }
  }
}
.pad_top{
  padding-top: 0.82rem;
}
.list_con{
  margin: 0.05rem auto 0;
  width: 7.04rem;
  .inner{
    padding: 0.35rem 0;
    border-bottom: 1px solid #F4F4F4;
  }
  .banner{
    width: 2.44rem;
    height: 1.84rem;
  }
  .new_r{
    img{
      width: 100%;
    }
    width: 4.25rem;
    margin-left: 0.3rem;
    .col_gray{
      font-size: 0.24rem;
      color: #505050;
    }
    .tit{
      h4{
        font-size: 0.36rem;
        color: #101010;
        font-weight: 800;
        width: 3rem;
      }
      i{
        padding: 0 0.04rem;
        line-height: 0.34rem;
        color: #2F72F5;
        font-size: 0.24rem;
        text-align: center;
        border: 1px solid currentColor;
        box-sizing: border-box;
        border-radius: 0.02rem;
      }
      span{
        width: 0.6rem;
        height: 0.34rem;
        text-align: center;
        line-height: 0.34rem;
        color: #fff;
        background-color: #24D064;
        font-size: 0.24rem;
        border-radius: 0.02rem;
      }
    }
  }
}
.new_list{
  .inner{
    .new_r{
      .col_gray{
        margin: 0.1rem 0;
      }
      .info{
        color: #505050;
        font-size: 0.24rem;
        p{
          margin-right: 0.2rem;
        }
        span{
          color: #FF6A18;
        }
      }
      .col_red{
        margin-top: 0.1rem;
        h4{
          font-size: 0.36rem;
          font-weight: 800;
        }
        span{
          font-size: 0.22rem;
        }
      }
      .text{
        margin-top: 0.1rem;
        font-size: 0.22rem;
        color: #A0A0A0;
        i{
          font-size: 0.18rem;
        }
      }
      .tel{
        width: 0.36rem;
        height: 0.36rem;
      }
    }
  }
}
</style>